import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import ChatDateHelper from "~/chat/ts/service/ChatDateHelper";


const __default__ = {
    name: "MessageTime"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dt: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    title: _ctx.dt.toLocaleDateTimeString(),
    class: "message-time"
  }, _toDisplayString(_ctx.dt.fromNow()), 9, _hoisted_1))
}
}

})